import React, { useRef } from 'react';

/* Material UI */
import { Grid, Typography } from '@mui/material';

/* Project */
import SelectService from './components/SelectService';
import StepsActionButtons from './components/StepsActionButtons';
import ActionsButtonsContainer from './components/ActionsButtonsContainer';

function ServiceForm() {
  const submitButtonRef = useRef(null);

  const handleNext = () => {
    submitButtonRef.current.click();
  };

  return (
    <>
      <SelectService submitButtonRef={submitButtonRef} />
      <ActionsButtonsContainer>
        <StepsActionButtons handleNext={handleNext} />
      </ActionsButtonsContainer>
    </>
  );
}

export default ServiceForm;
